import { useState } from "react";
import { toast } from "@/lib/toast";
import api from "@/lib/api";
import DeskConfirm from "@/components/crm/DeskConfirm";

/** DeleteTypeDialog — suppression d'un type de document (spec rev144) — R2 (iter393). */
export default function DeleteTypeDialog({ open, onOpenChange, type, docsCount = 0, onDeleted }) {
  const [saving, setSaving] = useState(false);

  const submit = async () => {
    if (!type) return;
    setSaving(true);
    try {
      await api.delete(`/document-types/${type.id}`);
      toast.success(`« ${type.name} » supprimé`, {
        description: docsCount > 0
          ? `${docsCount} document${docsCount > 1 ? "s" : ""} concerné${docsCount > 1 ? "s" : ""} — type de référence invalide.`
          : undefined,
      });
      onOpenChange(false);
      onDeleted?.();
    } catch (err) {
      toast.error("Suppression impossible", { description: err?.response?.data?.detail || "" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <DeskConfirm open={open} title={`Supprimer « ${type?.name || "—"} » ?`} busy={saving} confirmLabel={saving ? "Suppression…" : "Supprimer définitivement"}
      message={docsCount > 0
        ? <>Ce type est utilisé par {docsCount} document{docsCount > 1 ? "s" : ""}. Ils ne seront pas supprimés, mais leur type de référence deviendra <span style={{ color: "#F09595" }}>invalide</span>. Action irréversible.</>
        : "Aucun document n'utilise ce type pour l'instant. Action irréversible."}
      onClose={() => !saving && onOpenChange(false)} onConfirm={submit} testId="delete-type-dialog" />
  );
}
